import { useLocation } from "react-router-dom";
import {
  RecordContextProvider,
  useRecordContext,
  useRefresh,
  useTheme,
} from "react-admin";
import moment from "moment";
import { formatDateTime, formatDateTimeWithSeconds } from "../../utils/DateTimeUtils";
import React, { useCallback, useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  Rating,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableCell,
  TextField,
  Typography,
  Grid,
  Button as MUIButton,
  Select,
  MenuItem,
  Link,
} from "@mui/material";
import {
  GoogleMap,
  useJsApiLoader,
  DirectionsService,
  DirectionsRenderer,
  InfoWindow,
  Marker,
} from "@react-google-maps/api";
import BoltIcon from '@mui/icons-material/Bolt';

//Services
import { CookService } from "../../services/CookServices";
import { TrialsService } from "../../services/TrialServices";
import { OneMealService } from "../../services/OneMealService";

//Svg
import { LocationIcon, UserIcon } from "../Svg";

//Colors
import { colors } from "../../styles/colors";

//Utils
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";

//Common styles
import {
  TableWrapper,
  FlexBetween,
  GreenBadgeSquare,
  SectionTitleRow,
  SectionTitleSecondary,
  Title,
  WorkspacePanel,
  WorkspaceSubtitle,
  TableHeader,
  TableTopHeader,
  TableData,
  MapHeaderContainer,
  WorkSpaceTitleRow,
  Paragraph,
  InlineContainer,
  WhiteBgContainer,
  CustomTableRowTR,
  StyledTable,
  SectionTitle,
  WorkspaceSection,
  SectionHeader,
  SixColTwoRowGrid,
  ShowLabel,
  ButtonContainer,
} from "../../styles/commonStyles";
import CustomReferenceField from "../Common/CustomReferenceField";
import { TrackingNotesEnum } from "./VisitTrackerList";
import CallButton from "../Common/CallButton/CallButton";
import { UserType } from "../../enums/common";
import CookPartTimeCalendar from "../Cooks/CooksPartTimeCalendar";
import TransactionButton from "../Common/TransactionButton";

const cookService = new CookService();
const oneMealService = new OneMealService();
const trialsService = new TrialsService();

const containerStyle = {
  width: "100%",
  height: "40vh",
};

interface VisitTrackerDetailsTabProps {
  entityType?: string;
  visitId?: string;
  currentCookId?: string;
  cookId?: string;
}

export interface VisitComment {
  id: string;
  comment: string;
  commenterName: string;
  commenterEmail: string;
  timestamp: string;
}

interface InputProps {
  name: any;
  callback: (data: any) => void;
  color?:
  | "inherit"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning"
  | undefined;
}

const CustomButton = (props: InputProps) => {
  let record = useRecordContext();

  return (
    <MUIButton
      onClick={() => {
        props.callback(record);
      }}
      size={"small"}
      color={props.color || "secondary"}
      variant={"contained"}
      style={{ width: "max-content", fontSize: "12px" }}
    >
      {props.name}
    </MUIButton>
  );
};

const VisitTrackerMetaShow = ({
  entityType,
  visitId,
  cookId
}: VisitTrackerDetailsTabProps) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY as string,
  });

  const onUnmount = React.useCallback(function callback() { }, []);

  const { state } = useLocation() as { state: { visitData?: any} | null };

  const [directionsOptions, setDirectionsOptions] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [response, setResponse] = useState<any>(null);
  const [showDirections, setShowDirections] = useState(false);
  const [showInfoWindow, setShowInfoWindow] = useState(true);

  const [distanceInLastTenMin, setDistanceInLastTenMin] =
    useState<string>("---");
  const [openAllocationNote, setOpenAllocationNote] = useState<boolean>(false);
  const [openChefFeedback, setOpenChefFeedback] = useState<boolean>(false);
  const [note, setNote] = useState<string>("");
  const [service, setService] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const [theme] = useTheme();
  const currentTheme = theme.palette?.mode;
  const visitData = state?.visitData;

  const record = useRecordContext();
  const refresh = useRefresh();
  console.log("distance travel in last 10 min",loading, distanceInLastTenMin);

  const cookRating =
    entityType === 'ONE_MEAL_SERVICE' ? Number(
      data?.currentVisit?.cook?.cookFullProfile?.overallCustomerRating
        ?.chefitRating
    ) || 0 : Number(data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.profile?.cookFullProfile?.overallCustomerRating?.chefForPartyRating);


  //const cookId = entityType === 'ONE_MEAL_SERVICE' ? visitData?.cookId : (state?.cookId ? state.cookId : visitData?.ChefForPartyCookDetailsModels[0]?.cookId);

  const haversine = useCallback(
    (lat1: number, lon1: number, lat2: number, lon2: number) => {
      function toRadians(degrees: number) {
        return degrees * (Math.PI / 180);
      }
      const R = 6371;
      const dLat = toRadians(lat2 - lat1);
      const dLon = toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) *
        Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c * 1000;
    },
    []
  );

  const getDistanceInLastTenMin = useCallback(
    async (
      cookCoordinatesBeforeTenMinutes: { lat: number; long: number },
      cookCurrentCoordinates: { lat: number; long: number },
      cookUpcomingVisit: { lat: number; long: number }
    ) => {
      if (!cookUpcomingVisit?.lat || !cookUpcomingVisit?.long) {
        setDistanceInLastTenMin("---");
        return;
      }
      if (!cookCurrentCoordinates?.lat || !cookCurrentCoordinates?.long) {
        setDistanceInLastTenMin("---");
        return;
      }
      if (
        !cookCoordinatesBeforeTenMinutes?.lat ||
        !cookCoordinatesBeforeTenMinutes?.long
      ) {
        setDistanceInLastTenMin("---");
        return;
      }
      let dist1 = haversine(
        cookCurrentCoordinates?.lat,
        cookCurrentCoordinates?.long,
        cookUpcomingVisit?.lat,
        cookUpcomingVisit?.long
      );
      let dist2 = haversine(
        cookCoordinatesBeforeTenMinutes?.lat,
        cookCoordinatesBeforeTenMinutes?.long,
        cookUpcomingVisit?.lat,
        cookUpcomingVisit?.long
      );
      if (!dist1 || !dist2) {
        setDistanceInLastTenMin("---");
        return;
      }
      let final = dist2 - dist1;
      let distance = !isNaN(final)
        ? `${Number(final / 1000).toFixed(1)} km`
        : "---";
      setDistanceInLastTenMin(distance);
    },
    [haversine]
  );

  const loadData = useCallback(
    (enableLoading: boolean = true) => {
      if (!cookId) return;
      if (enableLoading) {
        setLoading(true);
      }
      setShowDirections(false);
      cookService
        .getCookActivity(Number(cookId), {
          referenceModelName: entityType,
          referenceId: visitId,
          date: visitData?.date,
        })
        .then((data: any) => {
          getDistanceInLastTenMin(
            data?.cookCoordinatesBeforeTenMinutes,
            data?.cookCurrentCoordinates,
            data?.cookUpcomingVisit
          );
          setData(data);

          setDirectionsOptions({
            origin: {
              lat: data?.cookCurrentCoordinates?.lat,
              lng: data?.cookCurrentCoordinates?.long,
            },
            destination: {
              lat: data?.cookUpcomingVisit?.lat,
              lng: data?.cookUpcomingVisit?.long,
            },
            travelMode: "DRIVING",
          });
          if (
            data?.cookCurrentCoordinates?.lat &&
            data?.cookCurrentCoordinates?.long &&
            data?.cookUpcomingVisit?.lat &&
            data?.cookUpcomingVisit?.long
          ) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "Latest Location Updated",
              type: CustomSnackbarTypes.SUCCESS,
            });
          } else {
            if (!data?.cookCurrentCoordinates?.lat) {
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Current Location of Cook Not Available",
                type: CustomSnackbarTypes.ERROR,
              });
            } else if (!data?.cookUpcomingVisit?.lat) {
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Upcoming Visit Location in not available",
                type: CustomSnackbarTypes.ERROR,
              });
            }
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [cookId, getDistanceInLastTenMin, visitData?.date, entityType, visitId]
  );

  useEffect(() => {
    loadData();
  }, [loadData]);

  const directionsCallback = useCallback((result: any, status: any) => {
    if (status === "OK") {
      setResponse(result);
      setShowDirections(true);
    } else {
      console.error("Directions request failed with status:", status);
    }
  }, []);

  const calculateETA = () => {
    if (response && response.routes && response.routes.length > 0) {
      const route = response.routes[0];
      if (route.legs && route.legs.length > 0) {
        const leg = route.legs[0];
        if (leg.duration && leg.duration.text) {
          // setDistance(leg?.distance?.value);
          // setDuration(leg?.duration?.value);
          return `${leg?.distance?.text} - ${leg?.duration?.text}`;
        }
      }
    }
    return "ETA not available";
  };

  const handleRefresh = () => {
    setShowDirections(false);
    loadData(true);
  };

  const getDistanceDetails = () => {
    if (response && response.routes && response.routes.length > 0) {
      const route = response.routes[0];
      if (route.legs && route.legs.length > 0) {
        const leg = route.legs[0];
        if (leg.duration && leg.duration.text) {
          return {
            distance: leg?.distance?.value,
            duration: leg?.duration?.value,
          };
        }
      }
    }
    return {
      distance: 0,
      duration: 0,
    };
  };

  const sendMessage = () => {
    let googleEta = getDistanceDetails();
    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
      title: "Are you sure?",
      message: "Please confirm to send the message",
      successLabel: "Confirm",
      failureLabel: "Cancel",
      onClose: (confirmed: boolean) => {
        if (confirmed) {
          if (!googleEta?.duration) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "There is no ETA available or it is Zero",
              type: CustomSnackbarTypes.ERROR,
            });
            return;
          }
          if (!googleEta?.distance) {
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
              message: "There is no Distance available or it is Zero",
              type: CustomSnackbarTypes.ERROR,
            });
            return;
          }
          cookService
            .sendWhatsApp({
              customerPhone: data?.cookUpcomingVisit?.customerPhoneNumber,
              cookName: data?.cookUpcomingVisit?.cookName,
              referenceModelName: data?.cookUpcomingVisit?.visitType,
              date: data?.cookUpcomingVisit?.date,
              time: data?.cookUpcomingVisit?.time,
              distance: Math.abs(googleEta?.distance / 1000).toFixed(1),
              eta: Math.abs(googleEta?.duration / 60).toString(),
            })
            .then(() => {
              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Message Sent Successfully",
                type: CustomSnackbarTypes.SUCCESS,
              });
            });
        }
      },
    });
  };

  useEffect(() => {
    if (!data?.cookUpcomingVisit?.id) return;
    if (openAllocationNote || openChefFeedback) {
      if (data?.cookUpcomingVisit?.visitType === "ONE_MEAL_SERVICE") {
        oneMealService
          .getOneMealService(data?.cookUpcomingVisit?.id)
          .then((res: any) => {
            setService(res?.data);
          });
      } else {
        trialsService
          .getTrialsById(data?.cookUpcomingVisit?.id)
          .then((res: any) => {
            setService(res?.data);
          });
      }
    }
  }, [
    data?.cookUpcomingVisit?.id,
    data?.cookUpcomingVisit?.visitType,
    openAllocationNote,
    openChefFeedback,
  ]);

  const distanceBetweenLastVisit = (
        cookPastVisit: {lat: number; long: number},
        cookUpcomingVisit: {lat: number; long: number}
    ) => {
        if(!cookUpcomingVisit?.lat || !cookUpcomingVisit?.long) {
            return '---';
        }
        if(!cookPastVisit?.lat || !cookPastVisit?.long) {
            return '---';
        }
        let dist = haversine(cookPastVisit?.lat, cookPastVisit?.long, cookUpcomingVisit?.lat, cookUpcomingVisit?.long);
        return !isNaN(dist) ? `${Number(dist/1000).toFixed(1)} km` : '---'
    };

  const handleClose = () => {
    setOpenAllocationNote(false);
    setOpenChefFeedback(false);
    setNote("");
    setService(null);
    refresh();
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12} md={9} height={'100%'}>
          <WorkspacePanel>
            <FlexBetween>
              <SectionTitleRow>
                <div
                  style={{
                    backgroundColor: "rgba(25, 117, 210, 0.1)",
                    padding: "12px",
                    borderRadius: "100px",
                  }}
                >
                  <UserIcon color={colors.primary} width={28} height={28} />
                </div>
                <div>
                  <InlineContainer>
                    <SectionTitleSecondary>
                      {entityType === 'ONE_MEAL_SERVICE' ? data?.currentVisit?.cookName : data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.cookName || "Name not assigned"}
                    </SectionTitleSecondary>
                    (
                    {cookRating > 0 && (
                      <Rating
                        value={Number(cookRating)}
                        precision={0.1}
                        readOnly
                        size="small"
                      />
                    )}
                    {cookRating > 0 && (
                      <p style={{ fontSize: "14px", color: "#666", margin: "0" }}>
                        {cookRating.toFixed(1)}
                      </p>
                    )}
                    )
                  </InlineContainer>
                  <InlineContainer>
                    <WorkspaceSubtitle>
                      Cook-ID:{' '}
                      {cookId ? (
                        <Link
                          href={`/#/Cooks/${entityType === 'ONE_MEAL_SERVICE'
                            ? data?.currentVisit?.cookId
                            : data?.currentVisit?.cooks?.find(
                              (cook: any) => cook.type === 'MAIN_CHEF'
                            )?.details?.cookId}/show`}
                          underline="hover"
                          sx={{ fontWeight: 500 }}
                        >
                          {cookId}
                        </Link>
                      ) : (
                        '—'
                      )}
                    </WorkspaceSubtitle>
                  </InlineContainer>
                  <Link href={`#/cook-activity/${entityType === 'ONE_MEAL_SERVICE'
                            ? data?.currentVisit?.cookId
                            : data?.currentVisit?.cooks?.find(
                              (cook: any) => cook.type === 'MAIN_CHEF'
                            )?.details?.cookId}`} target={'_self'} underline="none">
                      <TransactionButton
                          name={"View Cook Activity"}
                          onClickHandler={() => {}}
                      />
                </Link>
                </div>
              </SectionTitleRow>
              <div>
                <GreenBadgeSquare>
                  Work status: {data?.cookWorkStatus}
                </GreenBadgeSquare>

                <WorkspaceSubtitle>
                  Mode of transport: {data?.modeOfTransport}
                </WorkspaceSubtitle>
              </div>
            </FlexBetween>
            <br />
            <br />
            <WorkspaceSection>
              <SectionHeader>
                <WorkSpaceTitleRow>
                  <LocationIcon />
                  <SectionTitle>Current Visit {" "}
                    {data?.currentVisit?.isInstantChefit && <>(<BoltIcon sx={{color: "#FF9800", fontSize: 25, marginBottom: '-6px'}} />)</>}
                  </SectionTitle>
                </WorkSpaceTitleRow>
              </SectionHeader>
            </WorkspaceSection>

            <SixColTwoRowGrid>
              <div>
                <ShowLabel>Visit ID (Type)</ShowLabel>
                <Paragraph><Link
                  href={`/#/${data?.currentVisitReferenceModel === "ONE_MEAL_SERVICE" ? 'OneMealService' : 'ChefForParty'}/${data?.currentVisit?.id}/show`}
                  underline="hover"
                >
                  {data?.currentVisit?.id}
                </Link> {`( ${data?.currentVisitReferenceModel} )`}</Paragraph>
              </div>
              <div>
                <ShowLabel>Visit Time</ShowLabel>
                <Paragraph style={{ whiteSpace: 'nowrap' }}>
                  {formatDateTime(`${data?.currentVisit?.date} ${data?.currentVisit?.time}`)}
                </Paragraph>
              </div>
              <div>
                <ShowLabel>Customer Name</ShowLabel>
                <Paragraph>{data?.currentVisit?.customerName}</Paragraph>
              </div>
              <div>
                <ShowLabel>Tracker Notes</ShowLabel>
                <Paragraph>{data?.currentVisit?.trackingNotes || "-"}</Paragraph>
              </div>
              <div>
                <ShowLabel>Contact</ShowLabel>
                <Paragraph>
                  <CallButton toPhoneNumber={entityType === 'ONE_MEAL_SERVICE' ? data?.currentVisit?.cook?.mobile : data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.cookPhone} userType={UserType.COOK} referenceId={Number(visitId)} referenceModelName={entityType} />
                </Paragraph>
              </div>
              <div>
                <ShowLabel>Allow Late Checkin</ShowLabel>
                <Paragraph>
                  {entityType === "ONE_MEAL_SERVICE" ? (data?.currentVisit?.allowLateCheckIn ? "True" : "False") : "NOT APPLICABLE"}
                </Paragraph>
              </div>
              <div>
                <ShowLabel>Cook Status</ShowLabel>
                <Paragraph>{data?.currentVisit?.status}</Paragraph>
              </div>
              <div>
                <ShowLabel>Pre Check-in Time</ShowLabel>
                <Paragraph style={{ whiteSpace: 'nowrap' }}>
                  {
                    entityType === 'ONE_MEAL_SERVICE' ? (data?.currentVisit?.preCheckedInAt ? formatDateTimeWithSeconds(data?.currentVisit?.preCheckedInAt) : "-"
                    ) : (data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.preCheckedInAt ? formatDateTimeWithSeconds(data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.preCheckedInAt) : "-")
                  }
                </Paragraph>
              </div>
              <div>
                <ShowLabel>Address</ShowLabel>
                <Paragraph>{data?.currentVisit?.house?.fullAddress || "Not Available"} </Paragraph>
              </div>
              <div>
                <ShowLabel>Customer Number</ShowLabel>


                {/* <CallButton
                heading={'Customer phone number'}
                toPhoneNumber={data?.currentVisit?.customerPhoneNumber}
                userType={UserType.CUSTOMER}
                referenceId={Number(visitId)} 
                referenceModelName={entityType}
            /> */}
                <Paragraph>{entityType === 'ONE_MEAL_SERVICE' ? data?.currentVisit?.customerPhoneNumber : data?.currentVisit?.customerPhone}</Paragraph>
              </div>
              <div>
                <ShowLabel>Check-in TIme</ShowLabel>
                <Paragraph style={{ whiteSpace: 'nowrap' }}>
                  {entityType === 'ONE_MEAL_SERVICE' ? (data?.currentVisit?.checkedInAt ? formatDateTimeWithSeconds(data?.currentVisit?.checkedInAt) : "-"
                  ) : (data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkInTime ? formatDateTimeWithSeconds(data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkInTime) : "-")
                  }
                </Paragraph>
              </div>
              <div>
                <ShowLabel>Check-out TIme</ShowLabel>
                <Paragraph style={{ whiteSpace: 'nowrap' }}>
                  {entityType === 'ONE_MEAL_SERVICE' ? (data?.currentVisit?.checkedOutAt ? formatDateTimeWithSeconds(data?.currentVisit?.checkedOutAt) : "-"
                  ) : (data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkOutTime ? formatDateTimeWithSeconds(data?.currentVisit?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkOutTime) : "-")
                  }
                </Paragraph>
              </div>

            </SixColTwoRowGrid>

            <Paragraph style={{ margin: "24px 0px 16px 0px", fontWeight: "bold" }}>
              Comments
            </Paragraph>

            <div>
              {entityType === 'ONE_MEAL_SERVICE'  && data?.currentVisit?.allocationComments?.length ? (
                <Table
                  size="small"
                  style={{
                    border: `${theme.palette?.mode === "dark"
                        ? `1px solid ${colors.dark.borderSecondary}`
                        : `1px solid ${colors.light.borderSecondary}`
                      }`,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Comment</TableCell>
                      <TableCell>Commented By</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Time</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data?.currentVisit?.allocationComments.map((c: any) => (
                      <TableRow key={c?.id}>
                        <TableCell>{c?.comment}</TableCell>
                        <TableCell>{c?.commenterName}</TableCell>
                        <TableCell>{c?.commenterEmail}</TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }}>{formatDateTimeWithSeconds(c?.timestamp)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No comments available</Typography>
              )}



              {entityType === 'CHEF_FOR_PARTY'  && data?.currentVisit?.allocatorComments?.length ? (
                <Table
                  size="small"
                  style={{
                    border: `${theme.palette?.mode === "dark"
                        ? `1px solid ${colors.dark.borderSecondary}`
                        : `1px solid ${colors.light.borderSecondary}`
                      }`,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Comment</TableCell>
                      <TableCell>Commented By</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Time</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {data?.currentVisit?.allocatorComments.map((c: any) => (
                      <TableRow key={c?.id}>
                        <TableCell>{c?.comment}</TableCell>
                        <TableCell>{c?.commenterName}</TableCell>
                        <TableCell>{c?.commenterEmail}</TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }}>{formatDateTimeWithSeconds(c?.timestamp)}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No comments available</Typography>
              )}
            </div>
            <br />
            <ButtonContainer>
              <Button
                size={"small"}
                variant={"contained"}
                onClick={handleRefresh}
              >
                GET CURRENT LOCATION
              </Button>

              <Button
                size={"small"}
                variant={"contained"}
                onClick={() => {
                  setOpenAllocationNote(true);
                }}
                disabled={!data?.cookUpcomingVisit?.id}
                color={"success"}
              >
                Allocation Comment
              </Button>
              <Button
                size={"small"}
                variant={"contained"}
                onClick={() => {
                  setOpenChefFeedback(true);
                }}
                disabled={!data?.cookUpcomingVisit?.id}
                color={"success"}
              >
                Chef Feedback
              </Button>
              <Button
                size={"small"}
                variant={"contained"}
                onClick={sendMessage}
                disabled={
                  !data?.cookUpcomingVisit?.id ||
                  getDistanceDetails().distance >= 15000 ||
                  getDistanceDetails().duration > 3600
                }
                color={"success"}
              >
                Send Details via Whatsapp
              </Button>

              {
                data?.currentVisitReferenceModel === "ONE_MEAL_SERVICE" && <CustomButton
                  name={
                    data?.currentVisit?.allowLateCheckIn
                      ? "Remove Late Checkin"
                      : "Allow Late Checkin"
                  }
                  color="error"
                  callback={() => {
                    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                      message: (record as any)?.allowLateCheckIn
                        ? "Are you sure you want to remove late checkin?"
                        : "Are you sure you want to allow late checkin?",
                      onClose: (confirmed: boolean) => {
                        if (confirmed) {
                          console.log(
                            "close event triggered:",
                            data?.currentVisit?.id
                          );
                          oneMealService
                            .allowLateCheckin(data?.currentVisit?.id)
                            .then((res) => {
                              EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                message: "Allowed late checkin",
                                type: CustomSnackbarTypes.SUCCESS,
                              });
                              refresh();
                            });
                        }
                      },
                      title: "Confirmation",
                    });
                  }}
                />
              }
              <Select
                size="small"
                displayEmpty
                value={data?.currentVisit?.trackingNotes ?? ""}
                onChange={(e) => {
                  const selectedNote = e.target.value as TrackingNotesEnum;
                  cookService
                    .updateTrackerNotes(
                      Number(data?.currentVisit.id),
                      entityType as string,
                      selectedNote
                    )
                    .then(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Tracking note updated successfully",
                        type: CustomSnackbarTypes.SUCCESS,
                      });
                      window.location.reload();
                    })
                    .catch(() => {
                      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                        message: "Failed to update tracking note",
                        type: CustomSnackbarTypes.ERROR,
                      });
                    });
                }}
                sx={{ width: "200px" }}
              >
                <MenuItem value="" disabled>
                  Select Note
                </MenuItem>

                {Object.values(TrackingNotesEnum).map((note) => (
                  <MenuItem key={note} value={note}>
                    {note}
                  </MenuItem>
                ))}
              </Select>
            </ButtonContainer>
          </WorkspacePanel>
          <TableWrapper>
            <TableTopHeader>
              <Title>Visit Details</Title>
            </TableTopHeader>

            <div>
              <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
                <StyledTable>
                  <TableHead>
                    <TableRow
                      sx={{
                        backgroundColor: "rgba(232, 235, 237, 0.3) !important",
                      }}
                    >
                      <TableHeader>VisitId(Visit Type)</TableHeader>
                      <TableHeader>Tracking</TableHeader>
                      <TableHeader>Late Checkin</TableHeader>
                      <TableHeader>Tracking Status</TableHeader>
                      <TableHeader>Visit Time</TableHeader>
                      <TableHeader>Check-In</TableHeader>
                      <TableHeader>Check-Out</TableHeader>
                      <TableHeader>Customer</TableHeader>
                      <TableHeader>Comments</TableHeader>
                      <TableHeader>Call Attempted</TableHeader>
                      <TableHeader>Call Completed</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.allVisits.map((row: any) => {
                      const isCurrentVisit = row?.visitData?.id === data?.currentVisit?.id 
                      console.log("is current visit: ", isCurrentVisit, data?.currentVisit?.id)
                    return(
                      <CustomTableRowTR key={row?.visitData?.id} sx={{
                        backgroundColor: isCurrentVisit ? "rgba(255, 255, 0, 0.4) !important" : row?.visitData?.status === "FULFILLED" ? "rgba(0, 255, 0, 0.4) !important" : "inherit",

                        ":hover" :{
                          backgroundColor: isCurrentVisit ? "rgba(255, 255, 0, 0.4) !important" : row?.visitData?.status === "FULFILLED" ? "rgba(0, 255, 0, 0.4) !important" : "inherit",
                        }
                      }}>
                        <TableData>
                          <RecordContextProvider
                            value={{ visitId: row?.visitData?.id }}
                          >
                            <span style={{display: 'flex', alignItems: 'center' }}>
                            <CustomReferenceField
                              listName={
                                row?.referenceModelName === "ONE_MEAL_SERVICE"
                                  ? "OneMealService"
                                  : "ChefForParty"
                              }
                              source="visitId"
                            />
                            
                            {" - "}
                            
                            <Chip
                              label={
                                row?.referenceModelName === "ONE_MEAL_SERVICE"
                                  ? "Chefit"
                                  : "Party"
                              }
                              size="small"
                              sx={{
                                height: "22px",
                                fontSize: "11px",
                                fontWeight: 600,
                                borderRadius: "12px",
                                px: 0.75,
                                backgroundColor:
                                  row?.referenceModelName === "ONE_MEAL_SERVICE"
                                    ? "#ed6c02"
                                    : "#800080",
                                color:
                                  row?.referenceModelName === "ONE_MEAL_SERVICE"
                                    ? "#fff"
                                    : "#fff",
                              }}
                            />
                            {row?.visitData?.isInstantChefit && <BoltIcon sx={{color: "#FF9800", fontSize: 25}} />}

                            </span>
                            <br/>
                            <Chip
                              label={
                                row?.visitData?.status
                              }
                              size="small"
                              sx={{
                                height: "22px",
                                fontSize: "11px",
                                fontWeight: 600,
                                borderRadius: "12px",
                                px: 0.75,
                                backgroundColor: "#e6f4ea",
                                color: "#1e7e34",
                                marginTop: "6px",
                              }}
                            />

                          </RecordContextProvider>
                        </TableData>
                        <TableData>
                          <Select
                            size="small"
                            displayEmpty
                            value={row?.visitData?.trackingNotes ?? ""}
                            onChange={(e) => {
                              const selectedNote = e.target.value as TrackingNotesEnum;
                              cookService
                                .updateTrackerNotes(
                                  Number(row?.visitData?.id),
                                  row?.referenceModelName,
                                  selectedNote
                                )
                                .then(() => {
                                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: "Tracking note updated successfully",
                                    type: CustomSnackbarTypes.SUCCESS,
                                  });
                                  window.location.reload();
                                })
                                .catch(() => {
                                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: "Failed to update tracking note",
                                    type: CustomSnackbarTypes.ERROR,
                                  });
                                });
                            }}
                            sx={{ width: '200px' }}
                          >
                            <MenuItem value="" disabled>
                              Select Note
                            </MenuItem>

                            {Object.values(TrackingNotesEnum).map((note) => (
                              <MenuItem key={note} value={note}>
                                {note}
                              </MenuItem>
                            ))}
                          </Select>
                        </TableData>
                        <TableData>
                          {
                            data?.currentVisitReferenceModel === "ONE_MEAL_SERVICE" ? <CustomButton
                              name={
                                data?.currentVisit?.allowLateCheckIn
                                  ? "Remove Late Checkin"
                                  : "Allow Late Checkin"
                              }
                              color="error"
                              callback={() => {
                                EventBus.emitEvent(
                                  EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG,
                                  {
                                    message: (record as any)?.allowLateCheckIn
                                      ? "Are you sure you want to remove late checkin?"
                                      : "Are you sure you want to allow late checkin?",
                                    onClose: (confirmed: boolean) => {
                                      if (confirmed) {
                                        console.log(
                                          "close event triggered:",
                                          row?.visitData?.id
                                        );
                                        oneMealService
                                          .allowLateCheckin(row?.visitData?.id)
                                          .then((res) => {
                                            EventBus.emitEvent(
                                              EventBusEventsEnum.SNACKBAR_SHOW,
                                              {
                                                message: "Allowed late checkin",
                                                type: CustomSnackbarTypes.SUCCESS,
                                              }
                                            );
                                            refresh();
                                          });
                                      }
                                    },
                                    title: "Confirmation",
                                  }
                                );
                              }}
                            /> : "NOT APPLICABLE"
                          }
                        </TableData>
                        <TableData>
                          <Chip
                            label={row?.visitData?.trackingStatus}
                            style={{
                              backgroundColor:
                                row.trackingStatus === "Completed"
                                  ? "#e6f7e6"
                                  : row.trackingStatus === "In-Progress"
                                    ? "#fff8e1"
                                    : "#e3f2fd",
                              color:
                                row.trackingStatus === "Completed"
                                  ? "#2e7d32"
                                  : row.trackingStatus === "In-Progress"
                                    ? "#ff8f00"
                                    : "#1565c0",
                              fontWeight: 500,
                              fontSize: "14px",
                            }}
                          />
                        </TableData>
                        <TableData style={{ textAlign: "center", whiteSpace: 'nowrap' }}>
                          {formatDateTime(`${moment(row?.visitData?.date).format("YYYY-MM-DD")} ${row?.visitData?.time}`)}
                        </TableData>
                        <TableData style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                          {row?.referenceModelName === 'ONE_MEAL_SERVICE' ? (row?.visitData?.checkInTime ? formatDateTimeWithSeconds(row?.visitData?.checkInTime) : "-") : (row?.visitData?.ChefForPartyCookDetailsModels[0]?.checkInTime ? formatDateTimeWithSeconds(row?.visitData?.ChefForPartyCookDetailsModels[0]?.checkInTime) : "-")}
                        </TableData>
                        <TableData style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                          {row?.referenceModelName === 'ONE_MEAL_SERVICE' ? (row?.visitData?.checkOutTime ? formatDateTimeWithSeconds(row?.visitData?.checkOutTime) : "-") : (row?.visitData?.ChefForPartyCookDetailsModels[0]?.checkOutTime ? formatDateTimeWithSeconds(row?.visitData?.ChefForPartyCookDetailsModels[0]?.checkOutTime) : "-")}
                        </TableData>
                        <TableData style={{ textAlign: "center" }}>
                          {row?.visitData?.customerName}
                        </TableData>
                        {entityType === 'ONE_MEAL_SERVICE' && (
                                                  <TableData>
                          <Table size="small">
                            <TableHead>
                              <TableRow
                                sx={{
                                  backgroundColor:
                                    "rgba(232, 235, 237, 0.3) !important",
                                }}
                              >
                                <TableHeader>Comment</TableHeader>
                                <TableHeader>By</TableHeader>
                                <TableHeader>Email</TableHeader>
                                <TableHeader>Time</TableHeader>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {row?.visitData?.allocationComments &&
                                row?.visitData?.allocationComments.map((c: any) => (
                                  <CustomTableRowTR key={c.id}>
                                    <TableData sx={{ maxWidth: 400 }}>
                                      <Typography
                                        variant="body2"
                                        sx={{ whiteSpace: "pre-wrap" }}
                                      >
                                        {c.comment}
                                      </Typography>
                                    </TableData>
                                    <TableData>{c.commenterName}</TableData>
                                    <TableData>{c.commenterEmail}</TableData>
                                    <TableData style={{ whiteSpace: 'nowrap' }}>
                                      {formatDateTimeWithSeconds(c.timestamp)}
                                    </TableData>
                                  </CustomTableRowTR>
                                ))}
                            </TableBody>
                          </Table>
                        </TableData>
                        )}

                        {entityType !== 'ONE_MEAL_SERVICE' && (
                                                  <TableData>
                          <Table size="small">
                            <TableHead>
                              <TableRow
                                sx={{
                                  backgroundColor:
                                    "rgba(232, 235, 237, 0.3) !important",
                                }}
                              >
                                <TableHeader>Comment</TableHeader>
                                <TableHeader>By</TableHeader>
                                <TableHeader>Email</TableHeader>
                                <TableHeader>Time</TableHeader>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {row?.visitData?.allocatorComments &&
                                row?.visitData?.allocatorComments.map((c: any) => (
                                  <CustomTableRowTR key={c.id}>
                                    <TableData sx={{ maxWidth: 400 }}>
                                      <Typography
                                        variant="body2"
                                        sx={{ whiteSpace: "pre-wrap" }}
                                      >
                                        {c.comment}
                                      </Typography>
                                    </TableData>
                                    <TableData>{c?.commenterName}</TableData>
                                    <TableData>{c?.commenterEmail}</TableData>
                                    <TableData style={{ whiteSpace: 'nowrap' }}>
                                      {formatDateTimeWithSeconds(c?.timestamp)}
                                    </TableData>
                                  </CustomTableRowTR>
                                ))}
                            </TableBody>
                          </Table>
                        </TableData>
                        )}

                        <TableData style={{ textAlign: "center" }}>
                          {row?.callData.length}{" "}
                        </TableData>
                        <TableData style={{ textAlign: "center" }}>
                          {row?.callData?.filter(
                            (each: any) => each?.status === "completed"
                          ).length ?? 0}
                        </TableData>
                      </CustomTableRowTR>
                    )})}
                  </TableBody>
                </StyledTable>
              </TableContainer>
            </div>
          </TableWrapper>
        </Grid>
        <Grid item xs={12} md={3} >
          <Paper
            sx={{
              height: "100%",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              alignItems: 'center'
            }}
          >
            <Box
              sx={{
                padding: "12px",
                fontWeight: 600,
                borderBottom: "1px solid #eee",
              }}
            >
              Calender Details
            </Box>

            <Box sx={{ flexGrow: 1, width: "100%" }}>
              <CookPartTimeCalendar startDate={visitData?.date} endDate={visitData?.date} cookId={cookId ? Number(cookId) : undefined} hideOneDate={true} />
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <br />

      <WhiteBgContainer
        style={{
          border: `${theme.palette?.mode === "dark"
              ? `1px solid ${colors.dark.borderPrimary}`
              : `1px solid ${colors.light.borderPrimary}`
            }`,
        }}
      >
        <MapHeaderContainer>
          <div>
            <WorkSpaceTitleRow>
              <LocationIcon />
              <Paragraph>Map Location</Paragraph>
            </WorkSpaceTitleRow>
            
          </div>
          <div style={{display: "flex", alignItems: "center", gap: '16px'}}>
          <Typography fontWeight={500} fontSize={14}>Distance in last 10 mins: {distanceInLastTenMin}</Typography>
          <Typography fontWeight={500} fontSize={14}>Distance form last Visit: {distanceBetweenLastVisit(data?.cookPastVisit, data?.cookUpcomingVisit)}</Typography>
          <Typography fontWeight={500} fontSize={14} sx={{ whiteSpace: 'nowrap' }}>Last updated at: {formatDateTimeWithSeconds(data?.cookCurrentCoordinates?.createdAt)}</Typography>
          </div>
        </MapHeaderContainer>
        {isLoaded ? (
          <div>
            <GoogleMap
              mapContainerStyle={containerStyle}
              // zoom={7}
              onLoad={() => {
                loadData();
              }}
              onUnmount={onUnmount}
            >
              {data?.cookPastVisit?.lat && data?.cookPastVisit?.long && (
                <Marker
                  position={{
                    lat: data?.cookPastVisit?.lat,
                    lng: data?.cookPastVisit?.long,
                  }}
                  label={"C"}
                />
              )}
              {entityType === 'ONE_MEAL_SERVICE' ? (visitData?.coordinatesAtPreCheckin?.coordinates?.[1] &&
                visitData?.coordinatesAtPreCheckin?.coordinates?.[0] && (
                  <Marker
                    position={{
                      lat: visitData?.coordinatesAtPreCheckin?.coordinates[1],
                      lng: visitData?.coordinatesAtPreCheckin?.coordinates[0],
                    }}
                    label={"D"}
                  />
                )) : (visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.coordinatesAtPreCheckin?.coordinates?.[1] &&
                  visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.coordinatesAtPreCheckin?.coordinates?.[0] && (
                    <Marker
                      position={{
                        lat: visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.coordinatesAtPreCheckin?.coordinates?.[1],
                        lng: visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.coordinatesAtPreCheckin?.coordinates?.[0],
                      }}
                      label={"D"}
                    />
                  ))}
              {entityType === 'ONE_MEAL_SERVICE' ? (visitData?.checkInImages?.checkInLocation && (
                <Marker
                  position={{
                    lat: visitData?.checkInImages?.checkInLocation?.lat,
                    lng: visitData?.checkInImages?.checkInLocation?.long,
                  }}
                  icon={{
                    url: "/checkin.png", // Replace with your house icon URL
                    scaledSize: new window.google.maps.Size(60, 80), // Adjust the size as needed
                  }}
                />
              )) : (visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkInLocation && (
                <Marker
                  position={{
                    lat: visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkInLocation?.lat,
                    lng: visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkInLocation.long,
                  }}
                  icon={{
                    url: "/checkin.png", // Replace with your house icon URL
                    scaledSize: new window.google.maps.Size(60, 80), // Adjust the size as needed
                  }}
                />
              ))}
              {entityType === 'ONE_MEAL_SERVICE' ? (visitData?.checkOutImages?.checkOutLocation && (
                <Marker
                  position={{
                    lat: visitData?.checkOutImages?.checkOutLocation?.lat,
                    lng: visitData?.checkOutImages?.checkOutLocation?.long,
                  }}
                  icon={{
                    url: "/checkout.png", // Replace with your house icon URL
                    scaledSize: new window.google.maps.Size(60, 80), // Adjust the size as needed
                  }}
                />
              )) :
                (visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkOutLocation && (
                  <Marker
                    position={{
                      lat: visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkOutLocation?.lat,
                      lng: visitData?.cooks?.filter((cook: any) => cook.type === 'MAIN_CHEF')[0]?.details?.checkOutLocation?.long,
                    }}
                    icon={{
                      url: "/checkout.png", // Replace with your house icon URL
                      scaledSize: new window.google.maps.Size(60, 80), // Adjust the size as needed
                    }}
                  />
                ))

              }
              {visitData?.house?.lat && visitData?.house?.long && (
                <Marker
                  position={{
                    lat: visitData?.house?.lat,
                    lng: visitData?.house?.long,
                  }}
                  icon={{
                    url: "/house.png", // Replace with your house icon URL
                    scaledSize: new window.google.maps.Size(60, 60), // Adjust the size as needed
                  }}
                />
              )}
              {!showDirections &&
                directionsOptions?.origin?.lat &&
                directionsOptions?.destination?.lat && (
                  <DirectionsService
                    // @ts-ignore
                    options={{ ...directionsOptions }}
                    callback={directionsCallback}
                  />
                )}
              {/*{!showDirections && directionsOptions?.origin?.lat && directionsOptions?.destination?.lat && (*/}
              {/*    <DistanceMatrixService*/}
              {/*        // @ts-ignore*/}
              {/*        options={{...directionsOptions}}*/}
              {/*        callback={distanceCallback}*/}
              {/*    />*/}
              {/*)}*/}
              {showDirections &&
                directionsOptions?.origin?.lat &&
                directionsOptions?.destination?.lat &&
                response && <DirectionsRenderer directions={response} />}
              {showInfoWindow &&
                directionsOptions?.origin?.lat &&
                directionsOptions?.destination?.lat && (
                  <InfoWindow
                    position={directionsOptions?.destination}
                    onCloseClick={() => setShowInfoWindow(false)}
                  >
                    <div>Estimated Time of Arrival: {calculateETA()}</div>
                  </InfoWindow>
                )}
            </GoogleMap>
            <Grid sx={{ padding: "12px" }} md={12} sm={12} xs={12} item>
              <Box display={"flex"} justifyContent={"flex-end"}>
                <Box display={"flex"} alignItems={"center"} mr={2}>
                  <img
                    src={"/map_a.png"}
                    alt={"map"}
                    style={{ width: "20px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"Current Location"}</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"} mr={2}>
                  <img
                    src={"/map_b.png"}
                    alt={"mapB"}
                    style={{ width: "20px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"Destination"}</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"} mr={2}>
                  <img
                    src={"/map_c.png"}
                    alt={"mapC"}
                    style={{ width: "20px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"Last Visit"}</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <img
                    src={"/map_D.png"}
                    alt={"mapD"}
                    style={{ width: "20px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"Pre Checkin"}</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <img
                    src={"/checkin.png"}
                    alt={"mapD"}
                    style={{ width: "40px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"Check in"}</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <img
                    src={"/checkout.png"}
                    alt={"mapD"}
                    style={{ width: "40px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"Check out"}</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"}>
                  <img
                    src={"/house.png"}
                    alt={"house"}
                    style={{ width: "40px" }}
                  />
                  <Typography sx={{ ml: 1 }}>{"House"}</Typography>
                </Box>
              </Box>
            </Grid>
          </div>
        ) : (
          <Box
            sx={{
              height: "300px",
              backgroundImage:
                currentTheme === "dark"
                  ? "url(/map-placeholder-dark-bg.webp)"
                  : "url('/map-placeholder.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              filter: "blur(1px)",
              borderRadius: "0px 0px 12px 12px",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255,255,255,0.4)",
              }}
            >
              <Paragraph>Click ‘View on Map’ to load</Paragraph>
            </Box>
          </Box>
        )}
      </WhiteBgContainer>

      {(openChefFeedback || openAllocationNote) && (
        <Dialog
          open={openAllocationNote || openChefFeedback}
          onClose={handleClose}
        >
          <DialogTitle>
            {openChefFeedback ? "Chef Feedback" : `Tracker Notes`}
          </DialogTitle>
          <DialogContent>
            <Table size={"small"}>
              <TableHead>
                <TableRow>
                  <TableCell>Comment</TableCell>
                  <TableCell>Commenter email</TableCell>
                  <TableCell>Time</TableCell>
                </TableRow>
              </TableHead>
              {service && openChefFeedback && service?.chefFeedback?.length ? (
                service?.chefFeedback?.map((comment: any) => (
                  <TableRow>
                    <TableCell>{comment?.comment}</TableCell>
                    <TableCell>{comment?.commenterEmail}</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {formatDateTimeWithSeconds(comment?.timestamp)}
                    </TableCell>
                  </TableRow>
                ))
              ) : openChefFeedback ? (
                <caption>No Comments</caption>
              ) : (
                ""
              )}
              {service &&
                openAllocationNote &&
                service?.allocationComments?.length ? (
                service?.allocationComments?.map((comment: any) => (
                  <TableRow>
                    <TableCell>{comment?.comment}</TableCell>
                    <TableCell>{comment?.commenterEmail}</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                      {formatDateTimeWithSeconds(comment?.timestamp)}
                    </TableCell>
                  </TableRow>
                ))
              ) : openAllocationNote ? (
                <caption>No Comments</caption>
              ) : (
                ""
              )}
            </Table>
            <TextField
              sx={{ mt: 3 }}
              fullWidth
              label="Enter the Comment"
              value={note}
              variant={"filled"}
              onChange={(event) => {
                setNote(event.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color={"success"}
              onClick={() => {
                if (openChefFeedback) {
                  if (
                    data?.cookUpcomingVisit?.visitType === "ONE_MEAL_SERVICE"
                  ) {
                    oneMealService
                      .addHcFeedbackForOneMeal(data?.cookUpcomingVisit?.id, {
                        commentOrFeedback: note,
                      })
                      .then(() => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Successful",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        handleClose();
                      });
                  } else {
                    trialsService
                      .addHcFeedback(data?.cookUpcomingVisit?.id, {
                        commentOrFeedback: note,
                      })
                      .then(() => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Successful",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        handleClose();
                      });
                  }
                } else {
                  if (
                    data?.cookUpcomingVisit?.visitType === "ONE_MEAL_SERVICE"
                  ) {
                    oneMealService
                      .addAllocationNotesForOneMeal(
                        data?.cookUpcomingVisit?.id,
                        {
                          commentOrFeedback: note,
                        }
                      )
                      .then(() => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Successful",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        handleClose();
                      });
                  } else {
                    trialsService
                      .addAllocationNotes(data?.cookUpcomingVisit?.id, {
                        commentOrFeedback: note,
                      })
                      .then(() => {
                        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                          message: "Successful",
                          type: CustomSnackbarTypes.SUCCESS,
                        });
                        handleClose();
                      });
                  }
                }
              }}
              size={"large"}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              color={"error"}
              onClick={handleClose}
              size={"large"}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export default VisitTrackerMetaShow;
